import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import {io} from "socket.io-client";
import queryString from "query-string";
import {useClickOutside} from "hooks";
import {HOST, CHAT_TYPE, URL, PLAY_MODE_ACTION, MANPLUS_BANNER_AD_SECTION_ID} from "utils/constants";
import {addChatList, editChatMode, editRoom, setChatAlert} from "store/actions/chat";
import View from "./View";

const token = localStorage.getItem("redbrickToken");
const platformNamespace = "/redbrick-platform";
const CHAT_URL = URL.CHAT_SOCKET_SERVER + platformNamespace;

let socket;
let connectFlag = false;

if (token) {
  socket = io(CHAT_URL, {extraHeaders: {authorization: token}});
}

function Container({intl, isIPXMode}) {
  const dispatch = useDispatch();
  const userCi = useSelector(state => state.userinfo.id);
  const isSelfieModeActive = useSelector(state => state.selfie.isActivated);
  const [adInfo, setAdInfo] = useState(null);
  const [chatType, setChatType] = useState(CHAT_TYPE.MESSAGE);
  const [chatOption, setChatOption] = useState(null);
  const [isClickNickName, setIsClickNickName] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isShowPrivatePopUp, setIsShowPrivatePopUp] = useState(false);

  const chatListRef = useRef(null);
  const chatListBottomRef = useRef(null);
  const chatInputRef = useRef(null);
  useClickOutside(chatListRef, () => onChangeChatMode(false));

  const roomName = useSelector(state => state.chat.currentRoom);
  const chatList = useSelector(state => state.chat.chatList);
  const alert = useSelector(state => state.chat.alert);
  const playOption = useSelector(state => state.playOption);
  const currentChatMode = useSelector(state => state.chat.chatMode);

  const isShowChat = playOption === PLAY_MODE_ACTION.CHAT;

  useEffect(() => {
    setRoomName();
  }, []);

  // useEffect(() => {
  // if (token) {
  // setSocket();
  // }
  // }, [token]);

  // useEffect(() => {
  //   if (!socket) return;
  //   console.log(socket);
  //   connectSocket(socket);
  // }, [socket]);

  useEffect(() => {
    if (isShowChat) {
      getManplusAdBanner();
      if (chatType !== CHAT_TYPE.MESSAGE) {
        setChatType(CHAT_TYPE.MESSAGE);
      }
      if (chatInputRef.current) {
        chatInputRef.current.focus();
      }
      adInfo && fetchForTracking(adInfo.impression_api);
    }
  }, [isShowChat]);

  useEffect(() => {
    if (chatList.length === 0) return;
    if (playOption !== "chat" && !alert) {
      dispatch(setChatAlert(true));
    }
  }, [chatList]);

  const setRoomName = () => {
    const {pid} = queryString.parse(window.location.search);
    const roomName = `${HOST}_${pid ? pid : "test"}`;
    dispatch(editRoom(roomName));
  };

  const connectSocket = (soc, fromDisconnect = false) => {
    if (fromDisconnect) return;
    soc.on("connect", () => {});
    joinRoom(soc);
    getMessage(soc);
  };

  const getMessage = soc => {
    onMessage(CHAT_TYPE.MESSAGE, soc);
    onMessage(CHAT_TYPE.PRIVATE_MESSAGE, soc);
    onMessage(CHAT_TYPE.WORLD_MESSAGE, soc);
    onMessage(CHAT_TYPE.INVALIDATE, soc);
  };

  const onMessage = (type, soc) => {
    soc.on(type, data => {
      // TODO : check block user
      data.type = type;
      dispatch(addChatList(data));
      scrollToBottom();
    });
  };

  const joinRoom = soc => {
    soc.emit("joinRoom", {room: roomName});
    soc.on("disconnect", reason => {
      console.log("WEB SOCKET DISCONNECTED: ", reason);
      if (reason === "io server disconnect") {
        socket.connect();
      }
      soc.emit("joinRoom", {room: roomName});
    });
  };

  const onSubmit = message => {
    if (!socket) return;
    if (chatType === CHAT_TYPE.QUICK_MESSAGE) {
      socket.emit("message", {
        room: roomName,
        message: intl.formatMessage({id: message}),
      });
      onClickChatType(CHAT_TYPE.MESSAGE);
      return;
    }

    const inputRef = chatInputRef.current;
    if (inputRef.value === "") return;
    if (chatType === CHAT_TYPE.MESSAGE) {
      socket.emit("message", {room: roomName, message: inputRef.value});
    }
    if (chatType === CHAT_TYPE.PRIVATE_MESSAGE) {
      const receiveUserId = selectedUser.id ? selectedUser.id : selectedUser.ci;
      socket.emit("private-message", {receiveUserId, message: inputRef.value});
    }
    inputRef.value = null;
  };

  const sendWorldMessage = (message, color) => {
    if (!socket) return;
    socket.emit("world-message", {message, color});
    onClickChatType(CHAT_TYPE.MESSAGE);
  };

  const scrollToBottom = () => {
    chatListBottomRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  const onClickChatType = type => {
    onChangeChatMode(true);
    setChatType(type);
  };

  const onChangeChatMode = bool => {
    if (currentChatMode === bool) return;
    dispatch(editChatMode(bool));
  };

  const onClickChatOption = option => {
    setChatOption(option);
  };

  const getManplusAdBanner = async () => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get("pid");
    const randomNum = Math.floor((Math.random() * 10) / 5);

    const sectionId = MANPLUS_BANNER_AD_SECTION_ID["320_100"];

    const res = await fetch(
      `${URL.MANPLUS_AD}&a_section=${sectionId}&i_rich_flag=1${pid && `&i_request_id=${pid}`}${userCi && `&keyword=${userCi}`}`,
    );
    const AdBannerData = await res.json();
    if (!AdBannerData.adsinfo || AdBannerData.adsinfo.error_code) return;
    const {img_path, impression_api, click_api, click_tracking_api, landing_url, logo_img_path, logo_landing_url} =
      AdBannerData.adsinfo.ad[0];

    setAdInfo({
      img_path,
      impression_api,
      click_api,
      click_tracking_api,
      landing_url,
      logo_img_path,
      logo_landing_url,
    });
  };

  const fetchForTracking = async requestUrl => {
    if (!requestUrl) return;
    await fetch(requestUrl);
  };

  const onClickAdBanner = type => {
    if (type === "logo") {
      const {logo_landing_url} = adInfo;
      window.open(logo_landing_url, "_blank");
    } else {
      const {click_api, click_tracking_api, landing_url} = adInfo;
      fetchForTracking(click_api);
      fetchForTracking(click_tracking_api);

      window.open(landing_url, "_blank");
    }
  };

  if (socket) {
    if (!connectFlag) {
      connectFlag = true;
      console.log(socket);
      connectSocket(socket);
    }
  }

  return (
    <View
      intl={intl}
      isIPXMode={isIPXMode}
      isSelfieModeActive={isSelfieModeActive}
      adInfo={adInfo}
      chatType={chatType}
      chatOption={chatOption}
      chatList={chatList}
      chatListRef={chatListRef}
      chatListBottomRef={chatListBottomRef}
      chatInputRef={chatInputRef}
      selectedUser={selectedUser}
      isShowChat={isShowChat}
      isShowPrivatePopUp={isShowPrivatePopUp}
      isClickNickName={isClickNickName}
      setIsClickNickName={setIsClickNickName}
      setSelectedUser={setSelectedUser}
      setIsShowPrivatePopUp={setIsShowPrivatePopUp}
      onClickChatOption={onClickChatOption}
      onChangeChatMode={onChangeChatMode}
      onSubmit={onSubmit}
      onClickChatType={onClickChatType}
      sendWorldMessage={sendWorldMessage}
      onClickAdBanner={onClickAdBanner}
    />
  );
}

export default injectIntl(Container);
